import '@babel/polyfill'

import Vue from 'vue'

import 'bulma'

import store from'./scripts/store.js'
import router from'./scripts/router.js'
import useGtm from'./scripts/useGtm.js'

import 'three/examples/js/controls/DeviceOrientationControls.js'

useGtm(router)

window.app = new Vue({
	el: '#app',
  router,
  store,
})
